import React from 'react';

import { Modal as BootModal, Spinner } from 'react-bootstrap';
import { Button } from '../../components';

const Modal = ({
  title,
  body = '',
  primaryButtonTitle,
  secondaryButtonTitle,
  onClick,
  secondaryOnClick,
  isOpen = false,
  optionalClose = false,
  bodyContent = true,
  loading = false,
}) => (
  <BootModal show={isOpen}>
    <BootModal.Header>
      <BootModal.Title>{title}</BootModal.Title>
    </BootModal.Header>
    {!!bodyContent && <p style={{ padding: 20 }}>{body}</p>}
    <BootModal.Footer>
      <Button variant="primary" onPress={onClick} text={primaryButtonTitle || 'Sign Out'}>
        {loading && <Spinner animation="border" size="sm" />}
      </Button>
      {optionalClose && (
        <Button variant="primary" onPress={secondaryOnClick} text={secondaryButtonTitle || 'Cancel'} />
      )}
    </BootModal.Footer>
  </BootModal>
);

export default Modal;
